import React, { useState } from 'react';
import { Modal, Heading, Text } from 'basecamp';
import { acceptTermsThunk, logoutThunk } from 'features/app/redux/context';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../utils/locale';
import { getConfig } from './redux/features';

const TermsAcceptance: React.FunctionComponent = () => {
	const dispatch = useDispatch();

	const [loading, setLoading] = useState<boolean>(false);
	const termsAndConditionsUrl = useSelector(getConfig('terms_and_condition_url'));

	return (
		<Modal
			setAs="small"
			withTitle={translate('termsAcceptance.TITLE')}
			andBodyPadY={0}
			withActions={
				loading
					? []
					: [
							{
								title: translate('termsAcceptance.ACCEPT_TERMS'),
								type: 'accent',
								onClick() {
									setLoading(true);
									dispatch(acceptTermsThunk());
								},
							},
					  ]
			}
			withCancelText={translate('termsAcceptance.DECLINE_TERMS')}
			close={(e: React.MouseEvent<HTMLElement>) => {
				e.preventDefault();
				dispatch(logoutThunk());
			}}
		>
			<Heading setAs={'xlarge'} withColor="black">
				{translate('termsAcceptance.HEADER')}
			</Heading>
			<Text>
				{translate('termsAcceptance.BODY', {
					TERMS_CONDITIONS_LINK: termsAndConditionsUrl,
				})}
			</Text>
			<Text>{translate('termsAcceptance.BODY2')}</Text>
		</Modal>
	);
};

export default TermsAcceptance;
